import React from "react";
import { Field, FieldProps, FieldRenderProps } from "react-final-form";

import { TimePicker } from "@mui/x-date-pickers/TimePicker";

import moment, { Moment } from "moment";
import Icon, { IconName } from "src/components/Icon/Icon";
import "./SimpleTimePickerField.scss";

export interface ISimpleTimePickerProps<FieldValue, El extends HTMLElement>
  extends FieldProps<FieldValue, FieldRenderProps<FieldValue, El>> {
  label?: string;
}

export interface ISimpleTimePickerRenderProps
  extends ISimpleTimePickerProps<Date, HTMLElement>,
    FieldRenderProps<Date, HTMLElement> {}

export class SimpleTimePicker extends React.Component<ISimpleTimePickerRenderProps> {
  render() {
    const { input, meta, label, disabled, isRequired } = this.props;
    const value = input.value ? moment(input.value, "HH:mm") : null;

    return (
      <div
        className={
          disabled
            ? "time-picker-field-v2__wrap timePicker__disabled"
            : meta.touched && meta.error
              ? "time-picker-field-v2__wrap__error time-picker-field-v2__wrap"
              : "time-picker-field-v2__wrap"
        }>
        <ul>
          <li>
            <label>{label}</label>
            {isRequired ? <label className="required">&nbsp;*</label> : ""}
          </li>
          <li>
            <TimePicker
              className="timePicker"
              value={value}
              onChange={(date: Moment) => {
                const timeString = date ? date.format("hh:mm a") : null;
                input.onChange(timeString);
              }}
              onError={error => console.log("error", error)}
              slots={{
                openPickerIcon: () => <Icon name={IconName.Calendar} size="16px" />,
              }}
              slotProps={{
                textField: {
                  InputProps: {
                    sx: {
                      backgroundColor: "var(--app-color-secondary5)",
                      borderRadius: "8px",
                      height: "32px",
                    },
                  },
                },
              }}
            />
          </li>
          {meta.touched && meta.error && <span>{meta.error}</span>}
        </ul>
      </div>
    );
  }
}

export interface ISimpleTimePickerFieldProps
  extends ISimpleTimePickerProps<Date, HTMLElement>,
    FieldProps<Date, FieldRenderProps<Date, HTMLElement>> {}

export default function SimpleTimePickerField(props: ISimpleTimePickerFieldProps) {
  return <Field component={SimpleTimePicker} {...props} />;
}
